import { useState } from "react";
import { X, Key } from "@phosphor-icons/react";
import { toast } from "sonner";
import api, { formatErr } from "@/lib/api";

export default function ChangePasswordModal({ open, onClose }) {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  if (!open) return null;

  const submit = async (e) => {
    e.preventDefault();
    if (next !== confirm) {
      toast.error("New passwords do not match");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Password updated");
      setCurrent("");
      setNext("");
      setConfirm("");
      onClose();
    } catch (e) {
      toast.error(formatErr(e.response?.data?.detail) || "Failed to update password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/80 flex items-end sm:items-center justify-center z-[60] p-4">
      <form onSubmit={submit} className="w-full max-w-md border border-app-border bg-app-surface p-6" data-testid="change-password-modal">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            <Key size={16} className="text-[#007AFF]" />
            <h2 className="font-display font-bold text-lg">Change password</h2>
          </div>
          <button type="button" onClick={onClose} className="touch-target p-2 hover:bg-app-hover"><X size={16} /></button>
        </div>
        <div className="space-y-4">
          <div>
            <label className="block font-mono-d text-[10px] uppercase tracking-widest text-app-subtle mb-2">Current password</label>
            <input type="password" required autoComplete="current-password" value={current} onChange={(e) => setCurrent(e.target.value)}
              className="w-full bg-app-bg border border-app-border px-3 py-2.5 text-sm focus:outline-none focus:border-[#007AFF] min-h-[44px]" />
          </div>
          <div>
            <label className="block font-mono-d text-[10px] uppercase tracking-widest text-app-subtle mb-2">New password</label>
            <input type="password" required minLength={8} autoComplete="new-password" value={next} onChange={(e) => setNext(e.target.value)}
              className="w-full bg-app-bg border border-app-border px-3 py-2.5 text-sm focus:outline-none focus:border-[#007AFF] min-h-[44px]" />
          </div>
          <div>
            <label className="block font-mono-d text-[10px] uppercase tracking-widest text-app-subtle mb-2">Confirm new password</label>
            <input type="password" required minLength={8} autoComplete="new-password" value={confirm} onChange={(e) => setConfirm(e.target.value)}
              className="w-full bg-app-bg border border-app-border px-3 py-2.5 text-sm focus:outline-none focus:border-[#007AFF] min-h-[44px]" />
          </div>
        </div>
        <div className="flex gap-2 mt-6">
          <button type="button" onClick={onClose} className="btn-touch flex-1 py-2.5 text-xs border border-app-border hover:bg-app-hover">Cancel</button>
          <button type="submit" disabled={loading} className="btn-touch flex-1 py-2.5 text-xs bg-[#007AFF] hover:bg-[#3395FF] disabled:opacity-50">
            {loading ? "Saving…" : "Update"}
          </button>
        </div>
      </form>
    </div>
  );
}
